// extracted by mini-css-extract-plugin
export var bleedthroughColumnHeader = "JJmDx";
export var columnHeader = "h2KSz";
export var columnHeaderCompact = "aspKN";
export var columnHeaderContainer = "gFfsl";
export var columnHeaderCozy = "s6Xyn";
export var columnHeaderHovered = "OQICU";
export var columnHeaderRoomy = "DDtA5";
export var columnHeadersContainer = "s8wta";
export var columnHeadersContainerDenseless = "F24Ks";
export var columnHeadersContainerFlexBox = "a8KEA";
export var emptyFirstColumn = "ddb09";
export var mlColumnHeaderHover = "oHp6b";
export var newFocusStyles = "VG7Pm";
export var receivedColumnContainer = "kucbQ";
export var resizeHandle = "RfETL";
export var resizeHandleDeprecated = "IJPKD";
export var rpDenseless = "HKvAv";
export var senderColumnButtonMargin = "tazj5";
export var sortIconCompactOrCozy = "eyzjV";
export var sortIconRoomy = "o_YSF";
export var sortingEnabled = "aLhjV";